module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-Italic-74e35b6e9113ed59ae251ead78276305.ttf";